import React, { Suspense, lazy } from 'react';
import type {RouteObject} from 'react-router-dom';
import Loader from '../components/ui/Loader';

const Home = lazy(() => import('../pages/Home'));
const XplatView = lazy(() => import('../pages/Xplat'));
const AdminRedirect = lazy(() => import('../pages/AdminRedirect'));
const PageNotFound = lazy(() => import('../pages/PageNotFound'));

const xplatElement = (
  <Suspense fallback={<Loader />}>
    <XplatView />
  </Suspense>
);

export const routes: RouteObject[] = [
  { path: '/admin', element: <Suspense fallback={<Loader />}><AdminRedirect /></Suspense> },
  { path: '/', element: <Suspense fallback={<Loader />}><Home /></Suspense> },
  { path: '/plat', element: <Suspense fallback={<Loader />}><Home /></Suspense> },

  { path: '/plat/*', element: xplatElement },
  { path: '/plat-frame/*', element: xplatElement },

  // Catch-all route for 404 pages
  { path: '*', element: <PageNotFound /> }
];
